import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledCustomSearchInput = styled(Box)`
  .text-field {
    background: ${COLOR.white[100]};
  }
`;
